import { withInstall } from '../utils'
import _BackToTop from './BackToTop'
import './index.scss'

export const BackToTop = withInstall(_BackToTop)
export default BackToTop
